module.exports = "/shared/fonts/ayar.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/ayar.ttf
// module id = 22
// module chunks = 13